<script lang="ts">
  import Seed from '$icons/SeedIcon.svelte';
  import type { TopActivitiesItem } from '$src/utils/api/topActivities.util';
  import Media from '../common/media/Media.svelte';

  export let activity: TopActivitiesItem;
</script>

<div class="flex p-4 gap-x-4">
  <div class="flex-grow">
    <div class="mb-4 text-blueish-grey-800">
      <a class="font-semibold hover:underline" href="/profile/{activity.donorName}">
        {activity.donorName}
      </a>
      donated to
      <a class="font-semibold hover:underline" href="/profile/{activity.creatorName}">
        {activity.creatorName}
      </a>
    </div>

    <div class="flex items-center gap-x-1">
      <Seed />
      <div class="text-blueish-grey-600">{activity.seedAmount}</div>
    </div>
  </div>
  <a href="/for-you?post={activity.postId}">
    <div class="rounded-lg h-16 bg-gray-100 overflow-hidden" style="aspect-ratio: 75/55;">
      <Media src={activity.thumbnailUrl} alt="" class="w-full h-full object-cover" />
    </div>
  </a>
</div>
